module.exports = __webpack_public_path__ + "img/toolbox.1c0f7f0b.svg";